var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment, useCallback, useRef, useState, } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { ModalContext } from './Context.js';
import { ModalActions, ModalFooter } from './ModalFooter.js';
import { ModalHeader } from './ModalHeader.js';
export const Modal = (props) => {
    const { open = false, onClose, children, size: _size = 'lg', className } = props, rest = __rest(props, ["open", "onClose", "children", "size", "className"]);
    const initialSize = useRef(_size);
    const [size, setSize] = useState(_size);
    const sizeClsx = [
        size === 'md' && 'sm:max-w-md w-full',
        size === 'lg' && 'sm:max-w-lg w-full',
        size === 'xl' && 'sm:max-w-xl w-full',
        size === '2xl' && 'sm:max-w-2xl w-full',
        size === '3xl' && 'sm:max-w-3xl w-full',
        size === '5xl' && 'sm:max-w-5xl w-full',
        size === 'full' && 'w-full sm:inset-4 sm:w-auto sm:absolute',
        size === 'zen' && 'w-full h-screen sm:rounded-none',
    ];
    const toggleZenMode = useCallback(() => {
        setSize(size === 'zen' ? initialSize.current : 'zen');
    }, [size, initialSize]);
    return (React.createElement(ModalContext.Provider, { value: Object.assign(Object.assign({ showCloseBtn: true }, props), { size,
            toggleZenMode }) },
        React.createElement(BackgroundProvider, { backgroundType: "surface" },
            React.createElement(Transition, { appear: true, show: open, as: Fragment },
                React.createElement(Dialog, Object.assign({ as: "div", className: "fixed z-10 inset-0 overflow-y-auto", onClose: onClose }, rest),
                    React.createElement("div", { className: clsx('flex justify-center min-h-screen text-center sm:block') },
                        React.createElement(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0" },
                            React.createElement(Dialog.Overlay, { className: "fixed inset-0" },
                                React.createElement("div", { className: "absolute inset-0 bg-black/75", onClick: onClose }))),
                        React.createElement("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen", "aria-hidden": "true" }, "\u200B"),
                        React.createElement(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95", enterTo: "opacity-100 translate-y-0 sm:scale-100", leave: "ease-in duration-200", leaveFrom: "opacity-100 translate-y-0 sm:scale-100", leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" },
                            React.createElement("div", { className: twMerge(clsx('inline-block align-bottom sm:rounded-lg text-left shadow-xl transform transition-all sm:align-middle isolate', 'bg-surface-50 text-basicSurface-500', sizeClsx, size !== 'full' && size !== 'zen' && 'm-0 sm:m-4', size !== 'zen' &&
                                    'sm:max-h-[calc(100vh-2rem)] overflow-auto', className)) }, children))))))));
};
const ModalContent = props => {
    const { children, className, padding = true } = props, rest = __rest(props, ["children", "className", "padding"]);
    return (React.createElement("div", Object.assign({ className: clsx('flex-1', padding && 'px-4 py-5 sm:p-6', className) }, rest), children));
};
Modal.Header = ModalHeader;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.Actions = ModalActions;
//# sourceMappingURL=Modal.js.map